import React, { FunctionComponent, ReactNode } from 'react';
import { MainLayout } from './main';

export const MainLayoutWithTheme: FunctionComponent<{
  primaryColor: string;
  children: ReactNode;
}> = ({ children }) => <MainLayout>{children}</MainLayout>;
